























































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import {
    availableCompanyTypes,
    availableCompanyTargetTypes,
    availableContactViews,
    availableCommentVisibilities,
    availableRoles,
    Permission,
    Role,
} from '@/api/types'

@Component
export default class EditCompanyForm extends Vue {
    @Prop({ required: true }) company!: Company

    internalPermissions: Permission[] = []

    mounted() {
        this.internalPermissions = this.company.permissions
    }

    getInternalPermissions(permission: string) {
        const permissions = this.internalPermissions.find(internalPermission => internalPermission.name === permission)

        return permissions ? permissions.roles : []
    }

    setInternalPermissions(permission: string, roles: Role[]) {
        const permissions = this.internalPermissions.find(internalPermission => internalPermission.name === permission)

        if (permissions) {
            permissions.roles = roles
        } else {
            this.internalPermissions.push({
                name: permission,
                roles,
            })
        }
    }

    get availableCompanyTypeOptions() {
        return availableCompanyTypes().map(companyType => {
            return {
                label: this.$t(`company-type.${companyType}`),
                subtext: this.$t(`company-type.${companyType}_subtext`),
                value: companyType,
            }
        })
    }

    get availableCompanyTargetTypeOptions() {
        return availableCompanyTargetTypes().map(companyTargetType => {
            return {
                label: this.$t(`company-target-type.${companyTargetType}`),
                value: companyTargetType,
            }
        })
    }

    get availableContactViews() {
        return availableContactViews().map(contactView => {
            return {
                label: this.$t(`contact-view.${contactView}`),
                subtext: this.$t(`contact-view.${contactView}_subtext`),
                value: contactView,
            }
        })
    }

    get availableCommentVisibilities() {
        return availableCommentVisibilities().map(commentVisibility => {
            return {
                label: this.$t(`comment-visibility.${commentVisibility}`),
                subtext: this.$t(`comment-visibility.${commentVisibility}_subtext`),
                value: commentVisibility,
            }
        })
    }

    get dateRangeOptions() {
        return [
            { label: this.$t('referral-list.dateRange.all').toString(), value: 'all' },
            { label: this.$t('referral-list.dateRange.week').toString(), value: 'week' },
            { label: this.$t('referral-list.dateRange.month').toString(), value: 'month' },
            { label: this.$t('referral-list.dateRange.year').toString(), value: 'year' },
            { label: this.$t('referral-list.dateRange.thisWeek').toString(), value: 'this-week' },
            { label: this.$t('referral-list.dateRange.thisMonth').toString(), value: 'this-month' },
            { label: this.$t('referral-list.dateRange.thisYear').toString(), value: 'this-year' },
        ]
    }

    get roleOptions() {
        return availableRoles().map(value => ({
            label: this.$t(`role.${value}`),
            value,
        }))
    }

    get editablePermissions(): string[] {
        return [
            'referral.referredBy',
            'referral.reopen',
        ]
    }
}
